<template>
  <div class="leftBar" v-bind:class="{ smallLeftBar: isCollapse }">
    <i class="el-icon-s-unfold collapseIcon iconUnfold" @click="toggleCollapse()" v-show="isCollapse"></i>
    <!--    <div class="sideTop">
      <img class="sideLogo" src="../../static/images/logo.png" alt="">
    &lt;!&ndash; 如果需要展开收起菜单功能,打开这个注释
    <i class="el-icon-s-fold collapseIcon" @click="toggleCollapse()" v-show="!isCollapse"></i>
    &ndash;&gt;
    </div>
    <hr class="divider"/>-->
    <!-- 左上角返回工作台按钮 -->
    <div class="back-workbench-btn" @click="goToWorkbench">
      <span class="icon">←</span>
      <span class="text">返回工作台</span>
    </div>
    <el-menu :default-active="active" class="sideBar" :collapse="isCollapse" background-color="#272727" text-color="#fff"
      v-on:select="select" v-bind:uniqueOpened="true">

      <div :key="menu.url" v-for="menu in surveyMenuData">
        <el-submenu v-bind:index="menu.route" v-if="menu.child && menu.child.length">
          <template slot="title">
            <i v-bind:class="menu.icon"></i>
            <span>{{ menu.name }}</span>
          </template>
          <el-menu-item-group :key="subMenu.url" v-for="subMenu in menu.child">
            <el-menu-item v-bind:index="subMenu.route" style="padding-left: 50px;">{{
              subMenu.name
            }}</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-menu-item v-bind:index="menu.route" v-else>
          <i v-bind:class="menu.icon"></i>
          <span slot="title">{{ menu.name }}</span>
        </el-menu-item>
      </div>
    </el-menu>
  </div>
</template>

<script>
import Cookies from "js-cookie";

export default {
  name: "SideBar",
  data() {
    return {
      surveyMenuData: [],
      isCollapse: false,
      active: Cookies.get("menuTitle") || "index",
      canDownload: false
    };
  },
  computed: {
    isAdmin: ({ $store: { getters } }) => {
      if (getters.isAdmin + "" === "true") {
        return true;
      } else {
        return false;
      }
    }
  },
  async mounted() {
    await this.updateAdmin();
    await this.getCanDownload();
    this.initMenu();
  },
  methods: {
    initMenu() {
      /* let surveyMenuData = JSON.parse(localStorage.getItem('surveyMenuData'))
      this.surveyMenuData = surveyMenuData */
      this.surveyMenuData = [
        {
          child: [
            {
              url: "index",
              name: "正在运行",
              route: "/openSurvey/newSurvey?published=1"
            },
            {
              url: "newSurveyEdit",
              name: "待编辑",
              route: "/openSurvey/newSurvey?published=0"
            },
            {
              url: "newSurveyHistory",
              name: "历史问卷",
              route: "/openSurvey/newSurvey?published=2"
            }
          ],
          icon: "el-icon-s-order",
          id: 1,
          name: "问卷管理",
          route: "#"
        },
        {
          child: [],
          icon: "el-icon-s-order",
          id: 2,
          name: "任务管理",
          route: "/openSurvey/taskManage"
        },
        // {
        //   child: [],
        //   icon: "el-icon-s-custom",
        //   id: 3,
        //   name: "用户管理",
        //   route: "/userManage"
        // },
        {
          child: [],
          icon: "el-icon-data-analysis",
          id: 4,
          name: "统计报告",
          route: "/openSurvey/statisticReport"
        }
      ];

      if (!this.isAdmin) {
        this.surveyMenuData = [
          {
            child: [
              {
                url: "index",
                name: "正在运行",
                route: "/newSurvey?published=1"
              },
              {
                url: "newSurveyHistory",
                name: "历史问卷",
                route: "/newSurvey?published=2"
              }
            ],
            icon: "el-icon-s-order",
            id: 1,
            name: "问卷管理",
            route: "#"
          }
        ];
        if (this.canDownload) {
          this.surveyMenuData.push({
            child: [],
            icon: "el-icon-data-analysis",
            id: 3,
            name: "统计报告",
            route: "/statisticReport"
          });
        }
      }
    },
    // handleOpen: function () {},
    // handleClose: function () {},
    toggleCollapse: function() {
      this.isCollapse = !this.isCollapse;
      this.$emit("toggleCollapse");
    },
    select: function(route) {
      Cookies.set("menuTitle", route);
      this.$router.push(
        {
          path: `${route.indexOf("?") > -1 ? route.split("?")[0] : route}`,
          query: {
            published: route.indexOf("?") > -1 ? route.split("=")[1] : undefined
          }
        },
        () => {}
      );
    },
    getCanDownload: async function() {
      let { data } = await window.instance.get(
        openSurveyReqUrl + "account/canViewReport"
      );
      this.canDownload = data.data.result;
    },

    updateAdmin: async function() {
      let { data } = await window.instance.get(
        openSurveyReqUrl + "account/permission"
      );
      let admin = data.data.isAdmin;
      localStorage.setItem('isAdmin', admin)
      this.$store.commit('setAdmin', admin)
    },

    goToWorkbench() {
      window.location.replace("https://uat.lingshutong.cn/#/desktop")
    },
  }
};
</script>

<style scoped lang="sass">
.leftBar
  background: #272727
  display: flex
  flex-direction: column
  width: 260px
  position: fixed
  height: 100%
  overflow: auto
  top: 0
  left: 0
  z-index: 5
  transition: width 0.5s
  .collapseIcon
    font-size: 26px
    color: #fff
    cursor: pointer
  .iconUnfold
    margin: 10px auto 0
  .sideTop
    display: flex
    flex-direction: row
    margin: 20px auto
    justify-content: space-between
    width: 84%
    align-items: center
    .sideLogo
      width: 120px
      margin: auto
  .divider
    opacity: 0.3
    width: 84%
    margin-top: 0
  .sideBar
    border-right: 0

.leftBar.smallLeftBar
  width: 66px
  .sideLogo
    width: 44px
    margin: auto

.back-workbench-btn
  display: flex
  align-items: center
  gap: 12px
  padding: 12px 24px
  color: #fff
  cursor: pointer
  border-bottom: 1px solid #333
  transition: background 0.2s
  &:hover
    background: #333
  .icon
    font-size: 18px
  .text
    font-size: 18px
</style>



// WEBPACK FOOTER //
// src/openSurvey/components/SideBar.vue